var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    fill: "#CB8B65"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.4778 55.1298C79.4525 54.1672 80 52.8623 80 51.5017C80 50.1412 79.4525 48.8362 78.4778 47.8736L58.8515 28.5042C57.8751 27.5411 56.5508 27 55.1699 27C53.789 27 52.4647 27.5411 51.4882 28.5042C50.5118 29.4674 49.9632 30.7737 49.9632 32.1358C49.9632 33.4979 50.5118 34.8042 51.4882 35.7673L62.2313 46.3676L22.205 46.3676C20.8245 46.3676 19.5006 46.9085 18.5245 47.8713C17.5484 48.8342 17 50.1401 17 51.5017C17 52.8634 17.5484 54.1693 18.5245 55.1321C19.5006 56.0949 20.8245 56.6358 22.205 56.6358L62.2313 56.6358L51.4882 67.2327C51.0047 67.7096 50.6212 68.2757 50.3596 68.8988C50.0979 69.522 49.9632 70.1898 49.9632 70.8642C49.9632 71.5387 50.0979 72.2065 50.3596 72.8296C50.6212 73.4527 51.0047 74.0189 51.4882 74.4958C51.9717 74.9727 52.5457 75.351 53.1774 75.6091C53.8091 75.8672 54.4861 76 55.1699 76C55.8536 76 56.5307 75.8672 57.1624 75.6091C57.7941 75.351 58.368 74.9727 58.8515 74.4958L78.4778 55.1298Z",
    fill: "#FFE3D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNew);
export default __webpack_public_path__ + "static/media/ArrowNew.cb03cf35de89f4cfac0ec2820b5c6cb9.svg";
export { ForwardRef as ReactComponent };